export const PHONE_COUNTRY_OPTIONS = [
	{
		value: '+49',
		flag: '🇩🇪',
		localMask: '000 00000000',
		validate: (val) => /^\d{10,11}$/.test(val),
	},
	{
		value: '+48',
		flag: '🇵🇱',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+34',
		flag: '🇪🇸',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+33',
		flag: '🇫🇷',
		localMask: '0 00 00 00 00',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+44',
		flag: '🇬🇧',
		localMask: '0000 000000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+39',
		flag: '🇮🇹',
		localMask: '000 000 0000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+31',
		flag: '🇳🇱',
		localMask: '00 0000000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+351',
		flag: '🇵🇹',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+385',
		flag: '🇭🇷',
		localMask: '00 000 0000',
		validate: (val) => /^\d{8,9}$/.test(val),
	},
	{
		value: '+371',
		flag: '🇱🇻',
		localMask: '0000 0000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+90',
		flag: '🇹🇷',
		localMask: '000 000 0000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+32',
		flag: '🇧🇪',
		localMask: '0 00 00 00 00',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+380',
		flag: '🇺🇦',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+43',
		flag: '🇦🇹',
		localMask: '000 0000000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+41',
		flag: '🇨🇭',
		localMask: '00 000 00 00',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+420',
		flag: '🇨🇿',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+421',
		flag: '🇸🇰',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+46',
		flag: '🇸🇪',
		localMask: '00 000 00 00',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+45',
		flag: '🇩🇰',
		localMask: '0000 0000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+47',
		flag: '🇳🇴',
		localMask: '0000 0000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+358',
		flag: '🇫🇮',
		localMask: '00 00000000',
		validate: (val) => /^\d{9,10}$/.test(val),
	},
	{
		value: '+40',
		flag: '🇷🇴',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+36',
		flag: '🇭🇺',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+30',
		flag: '🇬🇷',
		localMask: '000 000 0000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+359',
		flag: '🇧🇬',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+381',
		flag: '🇷🇸',
		localMask: '00 000 0000',
		validate: (val) => /^\d{8,9}$/.test(val),
	},
	{
		value: '+386',
		flag: '🇸🇮',
		localMask: '00 000 000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+370',
		flag: '🇱🇹',
		localMask: '000 00000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+372',
		flag: '🇪🇪',
		localMask: '0000 0000',
		validate: (val) => /^\d{7,8}$/.test(val),
	},
	{
		value: '+353',
		flag: '🇮🇪',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+352',
		flag: '🇱🇺',
		localMask: '000 000 000',
		validate: (val) => /^\d{6,9}$/.test(val),
	},
	{
		value: '+356',
		flag: '🇲🇹',
		localMask: '0000 0000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+357',
		flag: '🇨🇾',
		localMask: '0000 0000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+375',
		flag: '🇧🇾',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+7',
		flag: '🇷🇺',
		localMask: '000 000 00 00',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+963',
		flag: '🇸🇾',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+212',
		flag: '🇲🇦',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+964',
		flag: '🇮🇶',
		localMask: '000 000 0000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+961',
		flag: '🇱🇧',
		localMask: '00 000 000',
		validate: (val) => /^\d{7,8}$/.test(val),
	},
	{
		value: '+20',
		flag: '🇪🇬',
		localMask: '00 0000 0000',
		validate: (val) => /^\d{10}$/.test(val),
	},
	{
		value: '+213',
		flag: '🇩🇿',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+216',
		flag: '🇹🇳',
		localMask: '00 000 000',
		validate: (val) => /^\d{8}$/.test(val),
	},
	{
		value: '+970',
		flag: '🇵🇸',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+962',
		flag: '🇯🇴',
		localMask: '0 0000 0000',
		validate: (val) => /^\d{8,9}$/.test(val),
	},
	{
		value: '+967',
		flag: '🇾🇪',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+218',
		flag: '🇱🇾',
		localMask: '00 000 0000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+93',
		flag: '🇦🇫',
		localMask: '000 000 000',
		validate: (val) => /^\d{9}$/.test(val),
	},
	{
		value: '+98',
		flag: '🇮🇷',
		localMask: '000 000 0000',
		validate: (val) => /^\d{10}$/.test(val),
	},
];
